import { render, staticRenderFns } from "./modalDegustacaoDropdownServico.vue?vue&type=template&id=5049f9ff&scoped=true&"
import script from "./modalDegustacaoDropdownServico.vue?vue&type=script&lang=js&"
export * from "./modalDegustacaoDropdownServico.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=5049f9ff&scoped=true&lang=css&"
import style1 from "./modalDegustacaoDropdownServico.vue?vue&type=style&index=1&id=5049f9ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049f9ff",
  null
  
)

export default component.exports